import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { AuthService } from 'services/auth.service';
import { AnswerService } from 'student/answer/answer.service';
import { DashboardService } from 'aplication/dashboard/dashboard.service';
import { courseFormatService } from 'aplication/courseformat/courseformat.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation_modal.component.html',
  styles: []
})
export class ConfirmationModalComponent implements OnInit {

  // this variable used for modal structure
  title: string;
  body: string;
  closeBtnName: string;
  submitBtnName: string;
  routeType: string;
  routeUrl: string;
  data: any;

  /* this variable used for sending back data to the caller function */
  // this for filtering data
  search: any;
  filter: any;

  // this for store callback data and send back to the caller function
  // FORGET PASSWORD, 
  messageClass: any;
  message: any;
  success: any;

  confirmBtn: Boolean = false;
  isProcessing: Boolean = false;

  // used for store this component value
  bodyData = "";
  isConfirm: Boolean = false; // this used for validate confirm() can execute or not

  submitBtnClassName: string;//change submit button color

  target_course_code;
  target_course_name;
  target_class_code;
  target_project_code;

  constructor(
    private router: Router,
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private answerService: AnswerService,
    private dashboardService: DashboardService,
    private courseformatService: courseFormatService, 
    private toastr: ToastrService,
  ) { 
  }

  ngOnInit() {
    if (this.routeType == 'forgetPassword') {
      if (this.data.email) {
        this.bodyData = this.data.email;
      } else if (this.data.loginid) {
        this.bodyData = this.data.loginid;
      }
    }
    if (this.routeType == 'deleteStudentPrivateData') {
      if (this.data) {
        this.target_course_code = this.data['target_course_code'];
        this.target_course_name = this.data['target_course_name'];
        this.target_class_code = this.data['target_class_code'];
        this.target_project_code = this.data['target_project_code'];
      }
    }
    //
    if(!this.submitBtnClassName){
      this.submitBtnClassName='btn-primary';
    }
  }

  confirm() {
    if (this.isConfirm) return;
    this.isConfirm = true;

    switch (this.routeType) {
      case 'toFeedback': // answer use this case
        this.redirectToFeedback();
        return;
      case 'studentSaveAnswer':
        this.studentSaveAnswer();
        return;
      case 'deleteImg': // edit course format use this case
        this.deleteImg();
        return;
      case 'cancelCourse':
        this.cancelCourse();
        return;
      case 'resetCourse':
        this.resetCourse();
        return;
      case 'forgetPassword': // forget password use this case
        this.forgetPassword();
        return;
      case 'deleteStudentPrivateData': // forget password use this case
        this.deleteStudentPrivateData();
        return;
      case 'other':
        console.log('other');
        this.closeModal();
        return;
    }
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  deleteStudentPrivateData(){
    // alert('deleteStudentPrivateData '+this.target_course_code);
    //dashboardに通知して日時入れる
    if(this.target_course_code){
      this.dashboardService.deleteStudentPrivateData(this.target_course_code)
      .then( result => {
        console.log(result);

        if(result && result['success']){
          if(result['running_other_course_code']){
            alert('他に実施中のコースがあるため､個人情報削除の実施できません。実行はキャンセルされました');
            console.log('running_other_course_code:'+result['running_other_course_code']);
          }else if(result['deleted_num']==0){
            alert('受講生が０人でした');
          }else{
            alert('【削除完了】　　クラス「'+this.target_course_name+'」に所属する受講者全ての個人情報の削除が完了しました! ('+result['deleted_num']+'人発見→'+result['deleted_run']+'人削除 ※人数には停止アドレスも含まれます)');
            // alert(result['deleted_num']+'人分のデータを個人情報削除しました!　(※人数には停止アドレスも含まれます)');

            this.dashboardService.deletedStudentPrivateDataDate.next({
              target_course_code:this.target_course_code,
              target_class_code:this.target_class_code,
              target_project_code:this.target_project_code,
              deleted_date:new Date()
            });
          }
          
        }else{
          alert('×実施しましたが削除完了できませんでした…');
          console.log(result);
        }

        this.closeModal();

      });
      
    }else{
      this.closeModal();
    }
    
  }

  redirectToFeedback() {
    this.router.navigateByUrl(this.routeUrl);
    this.closeModal();
  }

  studentSaveAnswer() {
    this.answerService.studentSaveAnswer(this.data)
    .then((res) => {
      this.router.navigateByUrl(this.routeUrl);
      this.closeModal();
    })
    .catch(err => console.log(err));
  }

  deleteImg() {
    this.isProcessing = true;
    
    let formData = new FormData();
    formData.append('imageNumber', this.data.imageNumber.toString());

    this.courseformatService.updateCourseFormatImg(this.data.type, formData, this.data.questionId)
    .then((res) => {
      this.toastr.success('画像を削除しました', '画像削除完了');
      this.courseformatService.processing = true;
      this.courseformatService.getCourseFormatEdit(this.data.courseId);
      this.closeModal();
    })
    .catch(err => console.log(err));
  }

  cancelCourse(){
    this.dashboardService.cancelCourse(this.data)
    .then( result => {
      this.dashboardService.processing = true;
      this.dashboardService.getApiByFilterAndSearch(this.filter, this.search);
      this.closeModal();
    });
  }

  resetCourse(){
    this.dashboardService.resetCourse(this.data)
    .then( result => {
      /*
      this.dashboardService.processing = true;
      this.dashboardService.getApiByFilterAndSearch(this.filter, this.search);
      this.closeModal();
      */
      this.router.navigateByUrl(this.routeUrl);
      this.closeModal();
      alert('リセットが実行されました');
    });
  }

  forgetPassword() {
    this.isProcessing = true;
    let user = {};
    // default for not student type (admin or customer)
    user = {
      email: this.data.email,
      url : this.data.url,
    };

    if (this.data.type == 'student') {
      user = {
        loginid: this.data.loginid,
        url: this.data.url,
        type: this.data.type
      };
    }

    if(this.data.dontsend){
      this.success = true;
      this.closeModal();
    }else{
      this.authService.sendMailPassword(user, data => {
        this.messageClass = data.errorMessage;
        this.message = data.messageData;
        this.success = data.success;
        this.closeModal();
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/component/shared/confirmation_modal/confirmation_modal.component.ts